import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import { TransactionGroupPeriodTypeCode } from 'generated/graphql';
import { Edit, FormTab, NumberInput, SelectInput, TabbedForm, TextInput } from 'react-admin';

export const CreditCardProductEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <TabbedForm>
      <FormTab label="Základné info">
        <ClientInput disabled label="Klient" source="client.id" />
        <InstitutionInput source="institution.id" />
        <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
        <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
      </FormTab>

      <FormTab label="Zmluva">
        <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
        <DateInput label="Dátum podpisu zmluvy" source="contractSignDate" />
        <DateInput label="Platnosť zmluvy do" source="contractEndDate" />
      </FormTab>

      <FormTab label="Platby">
        <ExpectedAmountInput label="Výška splátky" source="paymentPeriod.expectedAmount.amount" />
        <TextInput source="paymentPeriod.expectedAmount.currency" style={{ display: 'none' }} value="EUR" />
        <NumberInput label="Opakovať každých" source="paymentPeriod.periodCount" />
        <SelectInput
          choices={[
            { id: TransactionGroupPeriodTypeCode.Week, name: 'týždňov' },
            { id: TransactionGroupPeriodTypeCode.Month, name: 'mesiacov' },
          ]}
          label=""
          source="paymentPeriod.periodTypeCode"
        />
        <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
      </FormTab>

      <FormTab label="Údaje pre platbu">
        <TextInput
          label="Variabilný symbol"
          source="paymentInfo.variableSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput
          label="Špecifický symbol"
          source="paymentInfo.specificSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput
          label="Konštantný symbol"
          source="paymentInfo.constantSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput label="IBAN" source="paymentInfo.ibanForPayment" sx={{ maxWidth: '40em', width: '100%' }} />
      </FormTab>

      <FormTab label="Status">
        <ProductStatusInput label="Status" source="status" />
      </FormTab>
    </TabbedForm>
  </Edit>
);
